// CourseList.js
import React from 'react';
import { RefreshCcw } from 'lucide-react';


const CourseList = ({ courses, setSelectedCourse, selectedCourse, setClasses, setSelectedClass, onRefresh }) => {

    const sortedCategories = Object.keys(courses).sort((a, b) => courses[a].order - courses[b].order);

    return (
        <div>
            <div className='flex flex-row justify-between items-center mb-4'>
                <h2 className="text-lg font-bold">Courses</h2>
                <button className="btn btn-ghost btn-square" onClick={() => {
                    onRefresh();
                }}>
                    <RefreshCcw />
                </button>
            </div>
            <div className="space-y-4">
                {
                    sortedCategories.map((category, i) => {
                        const sortedCourses = courses?.[category]?.courses?.sort((a, b) => a?.fields?.order - b?.fields?.order);

                        return (
                            <div key={i} className='flex flex-col gap-2'>
                                <h3 className='text-lg font-bold'>{category}</h3>
                                <ul className='space-y-2 pl-2 border-l-2 border-gray-300 '>
                                    {
                                        sortedCourses.map((c, j) => {
                                            return (
                                                <li key={c?.sys?.id} className='w-full'>
                                                    <button
                                                        className={`btn h-auto py-2 text-left w-full leading-[1.1] justify-start` + (selectedCourse?.sys?.id === c?.sys?.id ? 'bg-[#00449c] text-white hover:bg-[#00449c]! hover:text-white!' : "")}
                                                        onClick={() => {
                                                            setSelectedCourse(c)
                                                            setClasses(c?.fields?.classes || []);
                                                            setSelectedClass(null);
                                                        }}
                                                    >
                                                        {c?.fields?.title || 'Untitled Course'}
                                                    </button>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        )
                    })
                }
                {/* {Object.keys(courses).map((course) => (
                    <li key={course?.sys?.id}>
                        <button
                            className={`btn w-full ` + (selectedCourse?.sys?.id === course?.sys?.id ? 'bg-[#00449c] text-white hover:bg-[#00449c]! hover:text-white!' : "")}
                            onClick={() => {
                                setSelectedCourse(course)
                                setClasses(course?.fields?.classes || []);
                                setSelectedClass(null);
                            }}
                        >
                            {course?.fields?.title || 'Untitled Course'}
                        </button>
                    </li>
                ))} */}
            </div>
        </div>
    );
};

export default CourseList;